var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AuthService } from '@/services/auth-service';
import { UserPreferenceService } from '@/services/user-preference-service';
import { Component } from 'vue-property-decorator';
import { lazyInject } from '@/dependency-injection';
import { TYPES } from '@/dependency-injection/types';
import BaseManagementPage from '@/components/base/BaseManagementPage';
import OpportunityTable from '@/pages/opportunity-management/shared/OpportunityTable.vue';
import OpportunityFiltersSidesheet from '@/pages/opportunity-management/opportunity-loads/components/OpportunityFiltersSidesheet.vue';
import OpenLoadPrompt from '@/pages/opportunity-management/shared/prompts/OpenLoadPrompt.vue';
import AcceptLoadPrompt from '@/pages/opportunity-management/shared/prompts/AcceptLoadPrompt.vue';
import DenyLoadPrompt from '@/pages/opportunity-management/shared/prompts/DenyLoadPrompt.vue';
import PushLoadPrompt from '@/pages/opportunity-management/shared/prompts/PushLoadPrompt.vue';
// Date functions
import * as format from 'date-fns/format';
import * as addDays from 'date-fns/add_days';
var OpportunityManagement = /** @class */ (function (_super) {
    __extends(OpportunityManagement, _super);
    function OpportunityManagement() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.filterDate = new Date();
        _this.loadingOpportunities = false;
        _this.isLoggedInUserCarrier = true; // Assume yes until we know for sure.
        return _this;
    }
    OpportunityManagement.prototype.beforeMount = function () {
        this.isLoggedInUserCarrier = this.authService.isLoggedInUserCarrier;
        this.serviceSymbol = TYPES.OpportunityService;
        this.expandByDefault();
    };
    OpportunityManagement.prototype.created = function () {
        this.setDefaultSort(['loadId', 'marketId', 'siteId'], [true, false, false]);
    };
    OpportunityManagement.prototype.getAll = function () {
        return __awaiter(this, void 0, Promise, function () {
            var defaultFilters, daysToAdd, desk, data, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, 4, 5]);
                        return [4 /*yield*/, this.userPreferenceService.getFiltersByModule('OPPORTUNITY_LOADS')];
                    case 1:
                        defaultFilters = _a.sent();
                        daysToAdd = this.userPreferenceService.getValueForComponent(defaultFilters, 'DATE');
                        desk = this.userPreferenceService.getValueForComponent(defaultFilters, 'DISPATCH_DESK');
                        return [4 /*yield*/, this.opportunityService.getOpportunityLoads(this.userPreferenceService.getValueForComponent(defaultFilters, 'SITE'), format(addDays(new Date(), +daysToAdd), 'YYYY-MM-DD'), this.userPreferenceService.getValueForComponent(defaultFilters, 'OPPORTUNITY_STATUS').split('|'), this.userPreferenceService.getValueForComponent(defaultFilters, 'MATERIAL_GROUP'), desk === 'ALL' ? null : desk, '', // carrier id
                            '', // carrier group id
                            this.userPreferenceService.getValueForComponent(defaultFilters, 'MARKET'), this.userPreferenceService.getValueForComponent(defaultFilters, 'PLATTS'))];
                    case 2:
                        data = _a.sent();
                        if (data.success === false) {
                            this.showSnackbar({ text: data.message, color: 'error' });
                            return [2 /*return*/, []];
                        }
                        else {
                            return [2 /*return*/, data.data];
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _a.sent();
                        console.error(error_1);
                        return [3 /*break*/, 5];
                    case 4:
                        this.loading = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    OpportunityManagement.prototype.refreshLoad = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            var loadResponse, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.opportunityService.getOpportunityLoad(payload.loadId)];
                    case 1:
                        loadResponse = _a.sent();
                        if (loadResponse.success === false) {
                            this.showSnackbar({ text: 'Unable to update load, please refresh', color: 'error' });
                            return [2 /*return*/];
                        }
                        // update the items with the updated load
                        this.updateItemsCollection(loadResponse.data, ['loadId']);
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        console.error(error_2);
                        this.showSnackbar({
                            text: 'Unable to update load, please refresh',
                            color: 'error',
                        });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    OpportunityManagement.prototype.filteredDateChange = function (filteredDate) {
        this.filterDate = filteredDate;
    };
    Object.defineProperty(OpportunityManagement.prototype, "opportunityService", {
        get: function () {
            return this.service;
        },
        enumerable: false,
        configurable: true
    });
    var _a, _b;
    __decorate([
        lazyInject(TYPES.UserPreferenceService),
        __metadata("design:type", typeof (_a = typeof UserPreferenceService !== "undefined" && UserPreferenceService) === "function" ? _a : Object)
    ], OpportunityManagement.prototype, "userPreferenceService", void 0);
    __decorate([
        lazyInject(TYPES.AuthService),
        __metadata("design:type", typeof (_b = typeof AuthService !== "undefined" && AuthService) === "function" ? _b : Object)
    ], OpportunityManagement.prototype, "authService", void 0);
    OpportunityManagement = __decorate([
        Component({
            components: {
                'opportunity-table': OpportunityTable,
                'opportunity-filters-sidesheet': OpportunityFiltersSidesheet,
                'open-load-prompt': OpenLoadPrompt,
                'accept-load-prompt': AcceptLoadPrompt,
                'deny-load-prompt': DenyLoadPrompt,
                'push-load-prompt': PushLoadPrompt,
            },
        })
    ], OpportunityManagement);
    return OpportunityManagement;
}(BaseManagementPage));
export default OpportunityManagement;
